import { AppSettingStored } from './../../utils/setting/app.setting';
import { LanguageHelper } from './../../utils/language-helper';
import { BaseModel } from "../base-model";
import moduleConstant from "../../common/module-constant";
import {GridConfigColumn , IGridConfigColumn} from "../common/grid-config.model";

//#region detail model
export interface IFavouriteFilterModel {
	Id?: number;
	UserId?: number;
	IsSystem?: any;
	LanguageId?: number;
	Type?: number;
	Condition?: Object;
	IsDefault?: boolean;
	GridConfig?: IGridConfigColumn
	NameNL?: string;
	NameFR?: string;
	NameEN?: string;
}
export class FavouriteFilterModel extends BaseModel<IFavouriteFilterModel>
	implements IFavouriteFilterModel {
	Id?: number;
	UserId?: number;
	IsSystem?: any;
	LanguageId?: number;
	Type?: number;
	Condition?: Object;
	IsDefault?: boolean;
	GridConfig?: IGridConfigColumn
	NameNL?: string;
	NameFR?: string;
	NameEN?: string;

	constructor(options?: IFavouriteFilterModel) {
		super(options);
		this.Id = this.Id || null;
		this.UserId = this.UserId || null;
		this.IsSystem = this.IsSystem || null;
		this.NameNL = this.NameNL || null;
		this.NameFR = this.NameFR || null;
		this.NameEN = this.NameEN || null;
		this.GridConfig = this.GridConfig || new GridConfigColumn({});
		this.LanguageId = this.LanguageId || undefined
		this.Condition = this.Condition || null;
	}
}
//#endregion

//#region list model
export interface IFavouriteFilterGroupModel {
	UserId?: number;
	Filters?: IFavouriteFilterModel[];
}
export class FavouriteFilterGroupModel
	extends BaseModel<IFavouriteFilterGroupModel>
	implements IFavouriteFilterGroupModel {
	UserId?: number;
	Filters?: IFavouriteFilterModel[];

	constructor(options?: IFavouriteFilterGroupModel) {
		super(options);
		this.UserId = this.UserId || null;
		this.Filters = this.Filters || [];
	}
}
//#endregion

//#region request model
export interface IFavouriteFilterRequestModel {
	UserId?: number;
	Type?: number;
	LanguageId?: number;
	Cache?: boolean;
}
export class FavouriteFilterRequestModel
	extends BaseModel<IFavouriteFilterRequestModel>
	implements IFavouriteFilterRequestModel {
	UserId?: number;
	Type?: number;
	LanguageId?: number;
	Cache?: boolean;
	constructor(options?: IFavouriteFilterRequestModel) {
		super(options);
		this.UserId = this.UserId || null;
		this.Type = this.Type || null;
		this.LanguageId = this.LanguageId || LanguageHelper.convertLanguageInt(AppSettingStored.instance().CurrentLanguageCode);
	}
}
//#endregion



//#region POST MODEL
export interface IPostFavouriteFilterModel {
	Id?: number;
	UserId?: number;
	Type?: number;
	
	NameNL?: string;
	NameFR?: string;
	NameEN?: string;

	LanguageId?: number;
	Module?: number;

	PropertyCondition?: Object;
	PersonCondition?: Object;
	DemandCondition?: Object;
	TaskCondition?: Object;
}
export class PostFavouriteFilterModel
	extends BaseModel<IPostFavouriteFilterModel>
	implements IPostFavouriteFilterModel {
	Id?: number;
	UserId?: number;
	Type?: number;
	
	NameNL?: string;
	NameFR?: string;
	NameEN?: string;

	LanguageId?: number;
	PropertyCondition?: Object;
	PersonCondition?: Object;
	DemandCondition?: Object;
	TaskCondition?: Object;

	constructor(options?: IFavouriteFilterModel) {
		super(options);
		this.Id = this.Id || null;
		this.UserId = this.UserId || null;
		this.Type = this.Type || null;
		
		this.NameNL = this.NameNL || null;
		this.NameFR = this.NameFR || null;
		this.NameEN = this.NameEN || null;
		
		this.LanguageId = this.LanguageId || LanguageHelper.convertLanguageInt(AppSettingStored.instance().CurrentLanguageCode);
		switch(options.Type){
			case moduleConstant.Object:
				this.PropertyCondition = options.Condition || null;
				break;
			case moduleConstant.Person:
				this.PersonCondition = options.Condition || null;
				break;
			case moduleConstant.Demand:
				this.DemandCondition = options.Condition || null;
				break;
			case moduleConstant.Task:
				this.TaskCondition = options.Condition || null;
				break;
		}
	}
}
//#endregion

//#region MAPPER

export interface IServiceModelMapper<TServiceModel, TClientModel>{
	FromServerToClient(model: TServiceModel) : TClientModel;
	FromClientToServer(model: TClientModel) : TServiceModel;
}
export class FavouriteFilterModelMapper implements IServiceModelMapper<PostFavouriteFilterModel, FavouriteFilterModel>{
	/**
	 * MAPPER: CONVERT FROM SERVER MODEL TO CLIENT MODEL
	 * @param model 
	 */
	FromServerToClient(model: PostFavouriteFilterModel): FavouriteFilterModel {
		let newModel =  new FavouriteFilterModel(model)
		switch(model.Type){
			case moduleConstant.Object:
				newModel.Condition = model.PropertyCondition;
				break;
			case moduleConstant.Person:
				newModel.Condition = model.PersonCondition;
				break;
			case moduleConstant.Demand:
				newModel.Condition = model.DemandCondition;
				break;
			case moduleConstant.Task:
				newModel.Condition = model.TaskCondition;
				break;
		}
		return newModel;
	}	
	
	/**
	 * MAPPER: CONVERT FROM CLIENT MODEL TO SERVER MODEL
	 * @param model 
	 */
	FromClientToServer(model: FavouriteFilterModel): PostFavouriteFilterModel {
		let newModel =  new PostFavouriteFilterModel(model)
		switch(model.Type){
			case moduleConstant.Object:
				newModel.PropertyCondition = model.Condition || null;
				break;
			case moduleConstant.Person:
				newModel.PersonCondition = model.Condition || null;
				break;
			case moduleConstant.Demand:
				newModel.DemandCondition = model.Condition || null;
				break;
			case moduleConstant.Task:
				newModel.TaskCondition = model.Condition || null;
				break;
		}
		return newModel;
	}

	
}
//#endregion
